import { EntityTypeEnum, ProjectRunConfigurationType } from "@app/projects/enumerators";
import { NetworkIntegrityActionStatus, NetworkIntegrityProviderTypes, NetworkIntegrityDisplayMode, NetworkIntegrityMembership } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";
export enum NetworkIntegrityFilterAction {
  IsLodingChanged = "IS_LOADING_CHANGED",
  ProjectRunConfigurationChanged = "PROJECT_RUN_CONFIGURATION_CHANGED",
  ProjectRunConfigurationIdChanged = "PROJECT_RUN_CONFIGURATION_ID_CHANGED",
  ProjectRunConfigurationDualTypeChanged = "PROJECT_RUN_CONFIGURATION_DUAL_TYPE_CHANGED",
  ProviderTypeFilterChanged = "PROVIDER_TYPE_FILTER_CHANGED",
  ServiceAreaFilterChanged = "SERVICE_AREA_FILTER_CHANGED",
  SpecialtyFilterChanged = "SPECIALTY_FILTER_CHANGED",
  ActionStatusFilterChanged = "ACTION_STATUS_FILTER_CHANGED",
  DisplayModeChanged = "DISPLAY_MODE_CHANGED",
  MembershipFilterChanged = "MEMBERSHIP_FILTER_CHANGED",
  NpiTypeFilterChanged = "NPI_TYPE_FILTER_CHANGED"
};

export type NetworkIntegrityFilterActions =
  { type: NetworkIntegrityFilterAction, value: NetworkIntegrityFilterState };

export interface NetworkIntegrityFilterState {
  actionStatus?: NetworkIntegrityActionStatus;
  displayMode?: NetworkIntegrityDisplayMode;
  isLoading?: boolean;
  membership?: NetworkIntegrityMembership;
  npiType?: EntityTypeEnum | null;
  projectRunConfiguration?: ProjectRunConfiguration;
  projectRunConfigurationId?: string;
  projectRunConfigurationDualType?: ProjectRunConfigurationType;
  providerType?: string;
  regionSetIds?: number[];
  specialtyCodes?: string[];
};

export const networkIntegrityFilterInitialState = (initialProviderType?: string, initialActionStatus?: NetworkIntegrityActionStatus, initialDisplayMode?: NetworkIntegrityDisplayMode, initialMembership?: NetworkIntegrityMembership, initialNpiType?: EntityTypeEnum | null): NetworkIntegrityFilterState => Object.freeze({
  actionStatus: initialActionStatus ?? NetworkIntegrityActionStatus.All,
  displayMode: initialDisplayMode ?? NetworkIntegrityDisplayMode.Current,
  isLoading: true,
  membership: initialMembership ?? NetworkIntegrityMembership.Primary,
  npiType: initialNpiType ?? null,
  projectRunConfigurationDualType: ProjectRunConfigurationType.DualMembershipPrimary,
  providerType: initialProviderType ?? NetworkIntegrityProviderTypes.Servicing,
  regionSetIds: [],
  specialtyCodes: [],
});

export const networkIntegrityFilterReducer = (state: NetworkIntegrityFilterState, action: NetworkIntegrityFilterActions): NetworkIntegrityFilterState => {
  switch (action.type) {
    case NetworkIntegrityFilterAction.IsLodingChanged:
      return Object.freeze({
        ...state,
        isLoading: action.value.isLoading,
      });
    case NetworkIntegrityFilterAction.ProjectRunConfigurationChanged:
      return Object.freeze({
        ...state,
        projectRunConfiguration: action.value.projectRunConfiguration,
      });
    case NetworkIntegrityFilterAction.ProjectRunConfigurationIdChanged:
      return Object.freeze({
        ...state,
        projectRunConfigurationId: action.value.projectRunConfigurationId,
      });
    case NetworkIntegrityFilterAction.ProjectRunConfigurationDualTypeChanged:
      return Object.freeze({
        ...state,
        projectRunConfigurationDualType: action.value.projectRunConfigurationDualType,
      });
    case NetworkIntegrityFilterAction.ProviderTypeFilterChanged:
      return Object.freeze({
        ...state,
        providerType: action.value.providerType,
      });
    case NetworkIntegrityFilterAction.ServiceAreaFilterChanged:
      return Object.freeze({
        ...state,
        regionSetIds: action.value.regionSetIds,
      });
    case NetworkIntegrityFilterAction.SpecialtyFilterChanged:
      return Object.freeze({
        ...state,
        specialtyCodes: action.value.specialtyCodes,
      });
    case NetworkIntegrityFilterAction.ActionStatusFilterChanged:
      return Object.freeze({
        ...state,
        actionStatus: action.value.actionStatus,
      });
    case NetworkIntegrityFilterAction.DisplayModeChanged:
      return Object.freeze({
        ...state,
        displayMode: action.value.displayMode
      });
    case NetworkIntegrityFilterAction.MembershipFilterChanged:
      return Object.freeze({
        ...state,
        membership: action.value.membership,
      });
    case NetworkIntegrityFilterAction.NpiTypeFilterChanged:
      return Object.freeze({
        ...state,
        npiType: action.value.npiType,
      });
    default:
      return state;
  }
};